module.exports = __webpack_public_path__ + "static/media/35.e3d8cd77.mp3";